<!--  -->
<template>
  <div>
    <div class="infoPaddingCss">
      <div>
        <div class="flexButton">
          <span class="fontWeight">订单信息</span>
        </div>
        <vxe-table auto-resize border="inner" :data="orderTableData" align="center">
          <vxe-table-column field="paymentsNum" title="结算编号" show-overflow>
            <template slot-scope="{ row }">
              <span>{{ row.paymentsNum }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ordersNumAttached" title="订单编号" show-overflow>
            <template slot-scope="{ row }">
              <span>{{ row.ordersNumAttached }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="relOrdersNum" title="关联主订单" show-overflow>
            <template slot-scope="{ row }">
              <a @click="openOrderDetail(row.relOrdersId)">{{ row.relOrdersNum }}</a>
            </template>
          </vxe-table-column>
          <vxe-table-column field="sellerName" title="销售方" show-overflow></vxe-table-column>
          <vxe-table-column field="saleMan" title="业务员" show-overflow></vxe-table-column>
          <vxe-table-column field="clientManage" title="客户经理" show-overflow></vxe-table-column>
        </vxe-table>
      </div>
      <div style="margin-top: 10px;" class="infoPaddingCss add-box">
        <div class="flexButton">
          <span class="fontWeight">结算信息</span>
        </div>
        <vxe-table
            auto-resize
            border="inner"
            align="center"
            :data="receivingTableData"
            :edit-rules="formRules"
            :edit-config="{trigger: 'click', mode: 'cell'}"
        >
          <vxe-table-column field="addTime" title="结算时间">
            <template v-slot="{ row }">
              <span v-if="!isEdit">{{ row.addTime }}</span>
              <vxe-input v-else v-model="row.addTime" placeholder="选择日期" type="date" transfer></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="totalAmount" title="结算金额">
            <template v-slot="{row}">
              <span>{{ row.amount }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="note" title="摘要" show-overflow>
            <template v-slot="{row}">
              <span>{{ row.note }}</span>
              <!--              <vxe-select v-else v-model="row.note" :options="noteList" transfer></vxe-select>-->
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" title="备注" show-overflow>
            <template v-slot="{row}">
              <span v-if="!isEdit">{{ row.remark }}</span>
              <vxe-input v-else v-model="row.remark" placeholder="请输入备注" transfer></vxe-input>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="add-box">
        <vxe-table
            show-overflow
            :auto-resize="true"
            class="table-upload-style"
            max-height="200"
            :data="uploadData"
            :edit-config="{trigger: 'click', mode: 'cell'}"
        >
          <vxe-table-column field="url" title="查看附件">
            <template v-slot="{row}">
              <upload-list :isEdit="isEdit" :row="row" :initFileList="uploadList" :view="'arrange'"></upload-list>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="modal-footer add-btn-box" v-if="!isEdit">
        <Button type="primary" style="border-radius: 5px;" @click="isEdit = true">编辑</Button>
      </div>
      <div class="modal-footer add-btn-box" v-else>
        <Button style="border-radius: 5px;" @click="isEdit = false">取消</Button>
        <Button type="primary" style="border-radius: 5px;" @click="commit">保存</Button>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import DetailModal from "@/views/logistics/DetailModal";
import viewOrderDetail from "@/mixin/viewOrderDetail";
import UploadList from "@/components/common/UploadList";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  components: {
    UploadList,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      orderTableData: [],
      showPicIndex: 0,
      receivingTableData: [],
      logisticsTableData: [],
      logisticDetailVisible: false,
      uploadData: [
        {
          fileUuidList: [],
        },
      ],
      uploadList: [],
      isEdit: false,
      paymentsDetail: {},
      noteList: [],
      formRules: {
        paymentTime: [{required: true, message: "请选择时间"}],
        note: [{required: true, message: "请选择摘要"}],
      },
    };
  },
  created() {
    this.getDict(58000, 'noteList');
  },
  methods: {
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async commit() {
      let tempCopy = {
        logisticsIdList: [],
      };
      tempCopy.id = this.receivingTableData[0].id;
      tempCopy.amount = this.receivingTableData[0].amount;
      tempCopy.paymentType = this.receivingTableData[0].paymentType;
      tempCopy.note = this.receivingTableData[0].note;
      tempCopy.paymentTime = this.receivingTableData[0].addTime ? this.$utils.timestamp(this.receivingTableData[0].addTime) : null;
      tempCopy.fileUuidList = this.uploadData[0].fileUuidList;
      tempCopy.remark = this.receivingTableData[0].remark;

      showLoading();
      let res = await $api.twoSettlement.request("update", tempCopy);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("保存成功");
        this.$emit('afterSave')
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getReceivingDetail(row) {
      this.receivingTableData = [];
      let data = {
        id: row.id,
      };
      let res = await $api.twoSettlement.request("detail", data);
      if (res.status === 1) {
        let data = res.data;
        this.orderTableData = [{
          ordersNumAttached: data.ordTwoOrdersAttached.ordersNumAttached,
          relOrdersNum: data.ordTwoOrdersAttached.relOrdersNum,
          sellerName: data.ordTwoOrdersAttached.sellerName,
          saleMan: data.ordTwoOrdersAttached.saleMan,
          clientManage: data.ordTwoOrdersAttached.clientManage,
          relOrdersId: data.ordTwoOrdersAttached.relOrdersId,
          paymentsNum: data.paymentsDetail.paymentsNum,
        }]
        let objReceive = {};
        objReceive.id = data.paymentsDetail.id;
        objReceive.amount = data.paymentsDetail.totalAmount;
        objReceive.paymentType = data.paymentsDetail.paymentType;
        objReceive.note = data.paymentsDetail.note;
        objReceive.remark = data.paymentsDetail.remark;
        objReceive.addTime = this.$utils.toDateString(data.paymentsDetail.addTime, 'yyyy-MM-dd');
        this.receivingTableData.push(objReceive);
        if (data.fileList != null) {
          data.fileList.map((i) => {
            this.uploadList.push(i);
          });
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    openOrderDetail(id) {
      if (!this.isHavePermission("ordersTwo:detail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！",
        });
        return;
      }
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/order2/orderdetail/${id}`,
      };
      window.open(obj.path);
      return false;
    },
  },
};
</script>
<style>
.modal-footer {
  box-sizing: border-box;
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 98% !important;
  position: absolute;
  bottom: 0;
}
</style>
